import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  axiosGetData,
  axiosPatchData,
  axiosPostData,
  methodsMap,
} from '../../helpers/axios';

export const setFilters = createAction<Record<string, string>>('setFilters');
export const refreshKey = createAction<number>('refreshKey');

interface AsyncThunkArgs<T = any> {
  data?: T;
  url: string;
  onError?: (p: any) => void;
  onSuccess?: (p: any) => void;
}

interface RunModalArgs<T = any> extends AsyncThunkArgs<T> {
  method: keyof typeof methodsMap;
}

export const updateBatches = createAsyncThunk('updateBatches', async (args: AsyncThunkArgs<string>, { rejectWithValue }) =>
  axiosPatchData({
    ...args,
    headers: { 'Content-Type': 'application/json' },
    rejectWithValue,
  })
);

export const createVariants = createAsyncThunk('createVariants', async (args: AsyncThunkArgs, { rejectWithValue }) =>
  axiosPostData({
    ...args,
    headers: { 'Content-Type': 'application/json' },
    rejectWithValue,
  })
);

export const fetchStockLocations = createAsyncThunk('fetchStockLocations', async (args: AsyncThunkArgs, { rejectWithValue }) =>
  axiosGetData({
    ...args,
    rejectWithValue,
    headers: { 'Content-Type': 'application/json' },
  })
);

export const fetchContext = createAsyncThunk('fetchContext', async (args: AsyncThunkArgs, { rejectWithValue }) =>
  axiosGetData({ ...args, rejectWithValue })
);

export const runModalAction = createAsyncThunk('runModalAction', async (args: RunModalArgs, { rejectWithValue }) =>
  methodsMap[args.method]({
    ...args,
    rejectWithValue,
  })
);

export const fetchTemplate = createAsyncThunk('fetchTemplate', async (args: AsyncThunkArgs, { rejectWithValue }) =>
  axiosGetData({ ...args, rejectWithValue })
);

export const setTemplate = createAction<any>('setTemplate');

export const saveTemplates = createAsyncThunk('saveTemplates', async (args: AsyncThunkArgs, { rejectWithValue }) =>
  axiosPatchData({
    ...args,
    headers: { 'Content-Type': 'application/json' },
    rejectWithValue,
  })
);

export const fetchVariantSelectedProducts = createAsyncThunk('fetchVariantSelectedProducts', async (args: AsyncThunkArgs, { rejectWithValue }) =>
  axiosGetData({ ...args, rejectWithValue })
);
